import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Input, Container } from '@mui/material';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';


const index = ({ className, mode, entityDocId, mandatory, maxLength, itemFunction, disabled, id, name, value, onChange, onBlur, user, instance, help, onLoadingChange, error, errorHelpText, onValidationField }) => {

  const handleChange = (event) => {
    console.log('CAMBIO FIEL-> ' + event);
    if (onChange) {
      onValidationField(false, '', id)
      onChange(event);
      if (mandatory && !event.target.value) {
        onValidationField(true, 'El campo es obligatorio', id)
      } else {
        onValidationField(false, '', id)
      }
    }
  };

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <Container>
          <Input
            type="file"
            inputProps={{ accept: '.jpg, .png, .pdf, .xls, .xlsx,', style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" } }}
            onChange={handleChange}
            className={className ?? undefined}
            variant="outlined"
            id={id}
          />
        </Container>
      </Tooltip>
    </ThemeProvider>
  )
}

export default index